import gql from "graphql-tag";

export const getMasterContentByBatchId = gql`
  query GetMasterContentByBatchId($id: ID!) {
    masterContents(
      where: {
        batch: { id: $id }
      }
    ) {
      id
      contentGroupsSort
      publishedContents {
        id
      }
      contentGroups {
        id
        title
        draft
        description
        contentsSort
        contents{
          id
          name
          type
          dueDate
          description
          instructions
          placeType
          placeDirection
          materials {
            id
            fileName
            url
            type
            uploadDate
          }
        }
      }
    }
  }
`;
